<template>
    <ui-modal
        :name="$mx_getModalName"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        :title="titleModal"
        icon="fal fa-users-class"
        size="xs"
    >
        <div class="modal-content">
            <ui-select-2
                v-if="!$mx_userIsManagerOrBroker"
                v-model="form.data.team_id"
                :label="form.fields.team_id.label + ':'"
                :data="teamOptions"
                :disabled="form.fields.team_id.disabled"
                :loading="loader.teamLoad"
                item-label="label"
                return-value="value"
                @input="selectManegertHandlerByTeamId"
            />

            <ui-select-2
                v-if="!$mx_userIsManagerOrBroker"
                v-model="form.data.manager_id"
                :label="form.fields.manager_id.label + ':'"
                :data="managerOptions"
                :disabled="form.fields.manager_id.disabled || !managerOptions.length"
                :loading="loader.managerLoad"
                item-label="label"
                return-value="value"
                @input="selectBrokerHandlerByManagerId"
            />

            <ui-select-2
                v-model="form.data.broker_id"
                :label="form.fields.broker_id.label + ':'"
                :data="brokerOptions"
                :disabled="form.fields.broker_id.disabled || !brokerOptions.length"
                :loading="loader.brokerLoad"
                item-label="label"
                return-value="value"
            />

            <ui-switch
                v-if="
                    changeResponsible.changeResponsible == 'ask' ||
                        ($mx_userIsAdminOrCollaborator &&
                            changeResponsible.changeResponsible == 'onlyAdminAsk')
                "
                id="responsible-customer"
                v-model="form.data.changeResponsibleCustomer"
                :checked="form.data.changeResponsibleCustomer"
                :disabled="!isFormDataChanged"
                name="changeResponsibleCustomer"
                label="Alterar também os responsáveis do cliente."
                design="xs primary"
            />
        </div>

        <template v-if="false">
            <div class="modal-content client-reason-area">
                <div class="client-reason">
                    <label>Qual o motivo da transferência?</label>
                    <textarea
                        v-model="form.data.clientReasonText"
                        placeholder="Digite..."
                        rows="3"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <div class="cancel-buttons">
                <ui-modal-cancel-button :modal-name="$mx_getModalName" :track-event="gtm.cancel"
                >Cancelar</ui-modal-cancel-button
                >
            </div>
            <ui-button
                :disabled="!canSubmit"
                type="button"
                design="md success mw-100"
                @click="submit"
            >Salvar</ui-button
            >
        </template>
    </ui-modal>
</template>

<script>
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSelect2, uiSwitch } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { team, deal, configuration } from '@/services/axios'
	import { storage } from '@/services/storage'

	import { mapGetters } from 'vuex'
	import {
		helpersMixin,
		loaderMixin,
		alertMixin,
		modalMixin,
		permissionsMixin,
		utilMixin,
	} from '@/mixins'

	import { defaultGtm } from './default'

	const defaultFormData = () => ({
		id: null,
		team_id: null,
		manager_id: null,
		broker_id: null,
		allow_fill: 0,
		changeResponsibleCustomer: false,
		clientReasonText: '',
	})

	const defaultOldFormData = () => ({
		team_id: null,
		manager_id: null,
		broker_id: null,
	})

	const defaultLoader = () => ({
		modalLoad: false,
		modalLoadSuccess: false,
		teamLoad: false,
		managerLoad: false,
		brokerLoad: false,
	})

	export default {
		name: 'ui-broker-modal',
		components: {
			uiModal,
			uiModalCancelButton,
			uiSelect2,
			uiSwitch,
			uiButton,
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, modalMixin, permissionsMixin, utilMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				form: {
					fields: {
						team_id: {
							label: 'Equipe',
							required: true,
							disabled: false,
						},
						manager_id: {
							label: storage.get('label_manager'),
							required: true,
							disabled: false,
						},
						broker_id: {
							label: storage.get('label_broker'),
							required: true,
							disabled: false,
						},
					},
					data: { ...defaultFormData() },
				},
				loader: { ...defaultLoader() },
				oldFormData: { ...defaultOldFormData() },
				teamOptions: [],
				managerOptions: [],
				brokerOptions: [],
				changeResponsible: {},
				userList: [],
				gtm: { ...defaultGtm() }
			}
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),

			titleModal() {
				const id = this.form.data.id ? ' – #' + this.form.data.id : ''
				return 'Alterar Responsável' + id
			},

			canSubmit() {
				return (
					this.allSelectsIsLoaded &&
					this.form.data.id &&
					parseInt(this.form.data.allow_fill) &&
					this.$mx_hasValue(this.form.data.team_id) &&
					this.$mx_hasValue(this.form.data.manager_id) &&
					this.isFormDataChanged
				)
			},

			allSelectsIsLoaded() {
				const { teamLoad, managerLoad, brokerLoad } = this.loader
				return !teamLoad && !managerLoad && !brokerLoad
			},

			isFormDataChanged() {
				return JSON.stringify(this.currentFormData) != JSON.stringify(this.oldFormData)
			},

			currentFormData() {
				const { team_id, manager_id, broker_id } = this.form.data
				return {
					team_id,
					manager_id,
					broker_id,
				}
			},

			validateFormData() {
				let data = { ...this.form.data }
				if (data.broker_id == null || data.broker_id.length == 0) {
					delete data.broker_id
				}
				return data
			},
		},

		created() {
			/** Carrega as configurações do formulário */
			configuration.getConfigurations().then((response) => {
				let data = response.data
				for (var prop in data) {
					if (Object.prototype.hasOwnProperty.call(data, prop)) {
						if (data[prop].name === 'customerDuplicate') {
							if (data[prop].value_long)
								this.changeResponsible = data[prop].value_long
						}
					}
				}
			})
		},

		mounted() {
			this.$root.$on('modal-open-' + this.name, async (deal) => {
				this.reset()

				if (deal) {
					this.form.data.id = deal.id
					this.form.data.allow_fill = deal.allow_fill

					this.$mx_setLoaderList(['teamLoad', 'managerLoad', 'brokerLoad'], true)

					if (!this.$mx_userIsManagerOrBroker) await this.teamHandler()
					if (deal.team_id) this.form.data.team_id = deal.team_id

					if (!this.$mx_userIsManagerOrBroker && deal.team_id)
						await this.manegerHandlerByTeamId(deal.team_id)
					if (deal.manager_id) this.form.data.manager_id = deal.manager_id

					if (deal.manager_id) await this.brokerHandlerByManagerId(deal.manager_id)
					if (deal.broker_id) this.form.data.broker_id = deal.broker_id

					this.$mx_setLoaderList(['teamLoad', 'managerLoad', 'brokerLoad'], false)
				}

				this.userList = []

				this.configFormToUserType()
				this.copyOldFormData()
			})
		},

		methods: {
			copyOldFormData() {
				const { team_id, manager_id, broker_id } = { ...this.form.data }
				this.oldFormData = {
					team_id,
					manager_id,
					broker_id,
				}
			},

			/**
			 * Método responsável por configurar o forumulário pelo tipo de usuario.
			 */

			configFormToUserType() {
				/**
				 * Caso o usuário logado seja do tipo gerente ou corretor, seleciona a equipe deste
				 * e desabilita o filtro de equipes
				 */
				if (this.$mx_userIsManagerOrBroker && !this.form.data.team_id) {
					this.$set(this.form.data, 'team_id', this.user.team ? this.user.team.id : null)
					this.$set(this.form.fields.team_id, 'disabled', true)
				}

				/**
				 * Caso o usuário logado seja do tipo gerente ou corretor, carrega o manager_id deste
				 * e desabilita o filtro de gerentes
				 */
				if (this.$mx_userIsManagerOrBroker && !this.form.data.manager_id) {
					if (this.$mx_userIsManeger)
						this.$set(this.form.data, 'manager_id', this.user.manger_id || null)
					//...
					else if (this.$mx_userIsBroker) {
						this.$set(
							this.form.data,
							'manager_id',
							this.user.manager ? this.user.manager.id : null,
						)
					}

					this.$set(this.form.fields.manager_id, 'disabled', true)
				}

				if (this.$mx_userIsBroker && !this.form.data.broker_id) {
					this.$set(this.form.data, 'broker_id', this.user.broker_id || null)
					this.$set(this.form.fields.broker_id, 'disabled', true)
				}
			},

			/**
			 * Handlers e select handlers de team, maneger e broker.
			 */

			async teamHandler() {
				this.teamOptions = await this.getTeams()
			},

			async manegerHandlerByTeamId(id) {
				this.managerOptions = await this.getManagersByTeamId(id)
			},

			async selectManegertHandlerByTeamId(id) {
				this.form.data.manager_id = null
				this.form.data.broker_id = null
	
				if (!this.$mx_hasValue(id) || !this.isFormDataChanged) return

				this.managerOptions = []
				this.brokerOptions = []

				this.$mx_setLoader('managerLoad', true)
				await this.manegerHandlerByTeamId(id)
				this.$mx_setLoader('managerLoad', false)
			},

			async brokerHandlerByManagerId(id) {
				this.brokerOptions = await this.getBrokersByManagerId(id)
			},

			async selectBrokerHandlerByManagerId(id) {
				this.form.data.broker_id = null

				if (!this.$mx_hasValue(id)) return

				this.$mx_setLoader('brokerLoad', true)
				await this.brokerHandlerByManagerId(id)
				this.$mx_setLoader('brokerLoad', false)
			},

			/**
			 * Getters do modal.
			 */

			async getTeams() {
				try {
					const teams = (await team.getAll('', { nocover: true, per_page: 1000 })).data
					return teams.data.map((option) => ({
						label: option.name,
						value: option.id,
					}))
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			async getManagersByTeamId(id) {
				try {
					const managers = (await team.getManagersByTeam(id)).data
					return managers.map((option) => ({
						label: option.first_name,
						value: option.manager_id,
					}))
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			async getBrokersByManagerId(id) {
				try {
					const brokers = await team.getBrokersByManager(id)
					return Object.values(brokers.data).map((option) => ({
						label: option.first_name,
						value: option.broker_id,
					}))
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			closeAnimation() {
				setTimeout(() => {
					this.$mx_setLoader('modalLoadSuccess', true)

					setTimeout(() => {
						this.$mx_closeModal()
						this.$mx_reloadTablePage()
					}, 1000)
				}, 500)
			},

			reset() {
				this.form.data = { ...defaultFormData() }
				this.loader = { ...defaultLoader() }
				this.oldFormData = { ...defaultOldFormData() }
				this.teamOptions = []
				this.managerOptions = []
				this.brokerOptions = []
			},

			async submit() {
				if (!this.canSubmit) return
				this.$mx_setLoader('modalLoad', true)

				try {
					await deal.update('', this.form.data.id, this.validateFormData)
					this.closeAnimation()

					this.$gtm.trackEvent(this.gtm.submit)
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.$mx_setLoader('modalLoad', false)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
